<template>
  <v-container fluid>
    <v-row class="mx-0 flex-wrap">
      <v-col cols="12" md="6">
        <date-selector
          v-if="isFilterDate"
          :dateFrom="date.from"
          :dateTo="date.to"
          @updateFrom="(val)=>{date.from = val}"
          @updateTo="(val)=>{date.to = val}"
          :disabled="loading"
          :clearable="dateClearable"
        />
      </v-col>
    </v-row>
    <v-row class="mx-0 flex-wrap" align="center">
      <v-col cols="12" md="3" v-for="(filter, key) in localFilters" :key="key">
        <v-text-field
          v-if="filter.type === 'text'"
          v-model="filterValues[key]"
          :disabled="loading"
          :label="filter.text"
          :clearable="filter.clearable !== false"
        ></v-text-field>
        <v-autocomplete
          v-else
          :items.sync="selectables[filter.items]"
          v-model="filterValues[key]"
          :disabled="loading"
          :label="filter.text"
          :clearable="filter.clearable !== false"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" v-if="hasActionButton">
        <v-btn
          @click="search"
          color="primary"
          :disabled="loading"
        ><v-icon>filter_list</v-icon></v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { fromPairs, toPairs } from 'lodash'
  import DateSelector from '@/components/Common/DateSelector'

  export default {
    props: {
      dateFrom: Number,
      dateTo: Number,
      dateClearable: Boolean,
      loading: Boolean,
      selectables: Object,
      filters: Object,
      isFilterDate: {
        type: Boolean,
        default: false
      },
      hasActionButton: {
        type: Boolean,
        default: true
      },
    },
    components: {
      DateSelector
    },

    data () {
      return {
        filterValues: {},
        date: {
          from: this.dateFrom,
          to: this.dateTo
        },
      }
    },

    computed: {
      localFilters () {
        const pairs = toPairs(this.filters).filter((item, key) => !item.hide)
        return fromPairs(pairs)
      },
    },

    watch: {
      date: {
        deep: true,
        handler (val) {
          this.$emit('updatePeriod', val)
        }
      },
      filterValues: {
        deep: true,
        handler (val) {
          this.$emit('updateFilters', val)
        }
      },
    },
    methods: {
      search () {
        this.$emit('search')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/DataFilter.vue